function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT } from '@/js/constants';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
import FilesService from '@/apps/data-platform/services/security/files_service';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
export default {
  name: 'TabGeneralView',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          organization: true,
          database_engine: true,
          data_operator: true,
          kdomain: true,
          ksubdomain: true,
          object_description: true,
          response_text: true
        };
      }
    }
  },
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      environ_initial: '',
      files: [],
      inputUploadFile: null,
      currentFile: {},
      isHovered: false,
      requiredFlag: null
    };
  },
  computed: _objectSpread({
    filterSubDomain: function filterSubDomain() {
      var _this = this;
      var selectbSubdomain = this.selectSubdomain.filter(function (Subdomain) {
        return Subdomain.domain.includes(_this.item.kdomain);
      });
      return selectbSubdomain;
    },
    isShowWorkFlow: function isShowWorkFlow() {
      return this.isChangeRequest === 'APPROVE_OWNER';
    },
    get_paths: function get_paths() {
      return this.item !== {} ? this.item.datasource_path.split(',') : [];
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'organizations'])),
  created: function created() {
    this.domain_table = window.userInfo.domain;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files;
    this.getPreviewImage();
    this.requiredFlag = this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA || this.item.environment === ENVIRONMENT_FLOW.PROD;
    console.log("flag: ", this.requiredFlag);
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onFileChange: function onFileChange(event) {
      var _this2 = this;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      if (!file || file === undefined) {
        return;
      }
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: "".concat(_this2.item.luid, "/files/").concat(file.name),
          type: BUCKET_DIRECTORY_TYPES.WORKBOOKS,
          domain_source: _this2.domain_table
        };
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              domainTable: _this2.domain_table,
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            _this2.files.push(_file);
            _this2.updateFiles();
            _this2.inputUploadFile = null;
          } else {
            _this2.inputUploadFile = null;
            tasks.toast.error(res['message']);
            //alert(res['message'])
          }
        });
      };
      fileReader.readAsDataURL(file);
    },
    updateFiles: function updateFiles() {
      var _this3 = this;
      this.item['files'] = this.files;
      var workbook = {
        domain: window.userInfo.domain,
        workbook: this.item
      };
      TableauDashboardService.tableauWorkBookAddUpdate(workbook).then(function (res) {
        _this3.isSend = false;
        if (res && res.code === 200) {
          if (!res.success) {
            tasks.toast.error(res.message);
            //alert(res.message)
          }
        }
      });
    },
    deleteFile: function deleteFile(record) {
      var _this4 = this;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          var files = _this4.files;
          _this4.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this4.updateFiles();
        }).then(function () {
          _this4.currentFile = {};
        });
      }
    },
    onClickLink: function onClickLink(file) {
      var _this5 = this;
      FilesService.readFile(file.fileLink).then(function (response) {
        _this5.isLoading = false;
        if (response.success) {
          _this5.image = response.data.base64;
          _this5.dataImage = response.data;
          _this5.filename = response.data.name.split('/').pop();
          _this5.contentType = response.data.contentType;
          _this5.currentFile = {
            fileLink: response.data.base64,
            fileName: response.data.name.split('/').pop(),
            contentType: response.data.contentType
          };
          _this5.$bvModal.show('preview-file');
        } else {
          _this5.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error(response.message);
          //alert(response.message)
        }
      });
    },
    openImage: function openImage(url) {
      var uriObj = {
        name: 'DisplayImage',
        query: {
          uris: url
        }
      };
      var urlNew = this.$router.resolve(uriObj);
      window.open(urlNew.href, '_blank');
    },
    getPreviewImage: function getPreviewImage() {
      var _this6 = this;
      if (this.item.preview_image) {
        FilesService.readFile(this.item.preview_image).then(function (response) {
          _this6.$set(_this6.item, 'workbook_image', response.data.base64);
        });
      }
    }
  }
};